export default __webpack_public_path__ + "static/media/tutorialWeb-4.2.1fafa023.png";